// extracted by mini-css-extract-plugin
module.exports = {"tabNav":"style-module__tabNav___B5DIr","tab":"style-module__tab___3UE1S","active":"style-module__active___2LsGv"};